import { Route } from "react-router";
import ClientCounterpartyPage from "./ClientCounterparty";

export default(<Route component={ClientCounterpartyPage} />)